function Published2026() {

  return (
    <>
      <div className="ml-10 mt-5">
        <div className="flex">
          <div className="w-1/6 text-center">2026</div>

          <div className="w-full">
              <div className="flex">
                  <div className="w-full">
                      <p>M. Kim and C. Vespa, <a href="https://arxiv.org/abs/2509.02105" target="_blank" className="text-sky-600">“On integral extensions between the abelianization functor and its symmetric powers.”</a></p>
                      <p>Annales de l’institut Fourier.</p>
                  </div>
              </div>

              <div className="flex mt-2">
                    <div className="w-full">
                        <p>M. Kim and C. Vespa, <a href="https://link.springer.com/article/10.1007/s40062-025-00390-9" target="_blank" className="text-sky-600">“On analytic exponential functors on free groups.”</a></p>
                        <p>Journal of Homotopy and Related Structures 21 (2026): 131–174.</p>
                    </div>
                </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default Published2026;